/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */

import { ROUTE_SEARCH_CONSTANTS } from '../../screens/routeinspectionsearch/routeInspectionSearchConstants';

// Action Types
export const ROUTE_SEARCH_ACTION_TYPES = {
  // Route Search Actions
  ROUTE_SEARCH_REQUEST: 'ROUTE_SEARCH_REQUEST',
  ROUTE_SEARCH_SUCCESS: 'ROUTE_SEARCH_SUCCESS',
  ROUTE_SEARCH_FAILURE: 'ROUTE_SEARCH_FAILURE',
  CLEAR_ROUTE_SEARCH: 'CLEAR_ROUTE_SEARCH',

  // Inspection Search Actions
  INSPECTION_SEARCH_REQUEST: 'INSPECTION_SEARCH_REQUEST',
  INSPECTION_SEARCH_SUCCESS: 'INSPECTION_SEARCH_SUCCESS',
  INSPECTION_SEARCH_FAILURE: 'INSPECTION_SEARCH_FAILURE',
  CLEAR_INSPECTION_SEARCH: 'CLEAR_INSPECTION_SEARCH',

  // Search Type Toggle
  SET_SEARCH_TYPE: 'SET_SEARCH_TYPE',

  // Search Data Actions
  UPDATE_ROUTE_SEARCH_DATA: 'UPDATE_ROUTE_SEARCH_DATA',
  UPDATE_INSPECTION_SEARCH_DATA: 'UPDATE_INSPECTION_SEARCH_DATA',

  // Form Selection Actions
  UPDATE_FORM_SELECTIONS: 'UPDATE_FORM_SELECTIONS',
  UPDATE_PAGINATION_STATE: 'UPDATE_PAGINATION_STATE',

  // State Persistence Actions
  SAVE_FORM_STATE: 'SAVE_FORM_STATE',
  RESTORE_FORM_STATE: 'RESTORE_FORM_STATE',
  CLEAR_FORM_STATE: 'CLEAR_FORM_STATE',
  RETAIN_SEARCH_DATA: 'RETAIN_SEARCH_DATA',

  // Reset Actions
  RESET_ROUTE_INSPECTION_SEARCH: 'RESET_ROUTE_INSPECTION_SEARCH'
};

// Route Search Actions
export const routeSearchRequest = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.ROUTE_SEARCH_REQUEST
});

export const routeSearchSuccess = (data) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.ROUTE_SEARCH_SUCCESS,
  payload: data
});

export const routeSearchFailure = (error) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.ROUTE_SEARCH_FAILURE,
  payload: error
});

export const clearRouteSearch = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.CLEAR_ROUTE_SEARCH
});

// Inspection Search Actions
export const inspectionSearchRequest = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.INSPECTION_SEARCH_REQUEST
});

export const inspectionSearchSuccess = (data) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.INSPECTION_SEARCH_SUCCESS,
  payload: data
});

export const inspectionSearchFailure = (error) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.INSPECTION_SEARCH_FAILURE,
  payload: error
});

export const clearInspectionSearch = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.CLEAR_INSPECTION_SEARCH
});

// Search Type Actions
export const setSearchType = (searchType) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.SET_SEARCH_TYPE,
  payload: searchType
});

// Search Data Actions
export const updateRouteSearchData = (data) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.UPDATE_ROUTE_SEARCH_DATA,
  payload: data
});

export const updateInspectionSearchData = (data) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.UPDATE_INSPECTION_SEARCH_DATA,
  payload: data
});

// Form Selection Actions
export const updateFormSelections = (formSelections) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.UPDATE_FORM_SELECTIONS,
  payload: formSelections
});

export const updatePaginationState = (paginationState) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.UPDATE_PAGINATION_STATE,
  payload: paginationState
});

// Reset Actions
export const resetRouteInspectionSearch = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.RESET_ROUTE_INSPECTION_SEARCH
});

// Retain search data action - follows same pattern as main search page
export const retainRouteInspectionData = (retainData) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.RETAIN_SEARCH_DATA,
  payload: retainData
});

// Async Actions (Thunks)

// Perform Route Search
export const performRouteSearch = (searchData) => {
  return async (dispatch, getState) => {
    dispatch(routeSearchRequest());
    
    try {
      // TODO: Replace with actual API call
      const response = await fetch(ROUTE_SEARCH_CONSTANTS.API_ENDPOINTS.ROUTE_SEARCH, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication headers here
        },
        body: JSON.stringify(searchData)
      });

      if (!response.ok) {
        throw new Error('Route search failed');
      }

      const data = await response.json();
      dispatch(routeSearchSuccess(data));
      return data;
    } catch (error) {
      dispatch(routeSearchFailure(error.message));
      throw error;
    }
  };
};

// Perform Inspection Search
export const performInspectionSearch = (searchData) => {
  return async (dispatch, getState) => {
    dispatch(inspectionSearchRequest());
    
    try {
      // TODO: Replace with actual API call
      const response = await fetch(ROUTE_SEARCH_CONSTANTS.API_ENDPOINTS.INSPECTION_SEARCH, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add authentication headers here
        },
        body: JSON.stringify(searchData)
      });

      if (!response.ok) {
        throw new Error('Inspection search failed');
      }

      const data = await response.json();
      dispatch(inspectionSearchSuccess(data));
      return data;
    } catch (error) {
      dispatch(inspectionSearchFailure(error.message));
      throw error;
    }
  };
};

// State Persistence Actions
export const saveFormState = (formState) => ({
  type: ROUTE_SEARCH_ACTION_TYPES.SAVE_FORM_STATE,
  payload: formState
});

export const restoreFormState = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.RESTORE_FORM_STATE
});

export const clearFormState = () => ({
  type: ROUTE_SEARCH_ACTION_TYPES.CLEAR_FORM_STATE
});

export default {
  // Route Search Actions
  routeSearchRequest,
  routeSearchSuccess,
  routeSearchFailure,
  clearRouteSearch,
  
  // Inspection Search Actions
  inspectionSearchRequest,
  inspectionSearchSuccess,
  inspectionSearchFailure,
  clearInspectionSearch,
  
  // Search Type Actions
  setSearchType,
  
  // Search Data Actions
  updateRouteSearchData,
  updateInspectionSearchData,
  updateFormSelections,
  updatePaginationState,
  
  // State Persistence Actions
  saveFormState,
  restoreFormState,
  clearFormState,
  retainRouteInspectionData,
  
  // Reset Actions
  resetRouteInspectionSearch,
  
  // Async Actions
  performRouteSearch,
  performInspectionSearch
};
